import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useEffect } from 'react';
import { WindowHelper } from '../utils/WindowHelper.js';
var useBreakpointRef = function useBreakpointRef(_ref) {
  var breakpoints = _ref.breakpoints,
    breakpointValues = _ref.breakpointValues,
    direction = _ref.direction;
  var containerRef = useRef(null);
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    breakpointIndex = _useState2[0],
    setBreakpointIndex = _useState2[1];
  var onBreakpointChange = function onBreakpointChange(index) {
    setBreakpointIndex(index);
  };
  useEffect(function () {
    return WindowHelper.watchBreakpoints(breakpoints, onBreakpointChange, direction, containerRef.current);
  });
  return {
    ref: containerRef,
    breakpointIndex: breakpointIndex,
    breakpointValue: breakpointIndex > -1 && breakpointValues ? breakpointValues[breakpointIndex] : null
  };
};
export { useBreakpointRef };